import React from "react";
import { Box } from "@mui/material";
import ApplicationPrintCardInfoItem from "my-tax/components/application-print-card-info-item";

export const MyTaxChildTypeInfo = () => {
  return (
    <Box style={{ padding: "16px" }}>
      <Box textAlign="center">{"Gyermek típusa:"}</Box>
      <Box
        style={{
          color: "#919699",
          marginTop: "4px",
          lineHeight: "24px",
        }}
      >
        <ApplicationPrintCardInfoItem
          label="V."
          value="Vérszerinti gyerek"
        />
        <ApplicationPrintCardInfoItem
          label="O."
          value="Örökbefogadott gyerek"
        />
      </Box>
    </Box>
  );
};

export default MyTaxChildTypeInfo;
